// extracted by mini-css-extract-plugin
export default {"failedColumnContainer":"SpotWorkerRequestFailDialog_failedColumnContainer__VFxMw"};